const navbar = [
  {
    "link": "/",
    "section": "home",
    "text":"Home"
  },
  {
    "link":"/about",
    "section":"about",
    "text":"About"
  },
  {
    "link":"/design",
    "section":"design",
    "text":"Design"
  },
  {
    "link":"/coding",
    "section":"coding",
    "text":"Coding"
  }
];

export default navbar;